/**
 * AdBanner — bandeau publicitaire central (ads.amia.fr), best-effort et ISOLÉ.
 * Ne rend RIEN si la pub n'est pas configurée pour le site (config.ads.enabled). Le slot
 * s'auto-mesure et la centrale décide le format (via @mostajs/ad-slot). Enveloppé dans
 * AdErrorBoundary : la pub ne casse jamais l'affichage de la file.
 * @author Dr Hamid MADANI <drmdh@msn.com>
 */
import React from 'react';
import { AdSlot } from '@mostajs/ad-slot/react';
import AdErrorBoundary from './AdErrorBoundary';

export default function AdBanner({ ads, placement = 'scene:bandeau', site = '', style, className }) {
  if (!ads || !ads.enabled || !ads.base || !ads.key) return null;
  return (
    <AdErrorBoundary>
      <AdSlot
        base={ads.base}
        account={ads.account}
        adKey={ads.key}
        placement={placement}
        site={site}
        className={className || 'ads-amia-slot'}
        style={style}
      />
    </AdErrorBoundary>
  );
}
